import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'mobile-button',
  props: {
    position: null,
    bg: null,
    active: null,
    width: null,
    height: null,
    top: null,
    left: null
  },
  setup: function setup(__props) {
    var props = __props;
    _useCssVars(function (_vm, _setup) {
      return {
        "4f15fa8f": _setup.active
      };
    });
    var style = computed(function () {
      var _props$bg2;
      var w = typeof props.width === "number" ? "".concat(props.width / 100, "rem") : props.width;
      var h = typeof props.height === "number" ? "".concat(props.height / 100, "rem") : props.height;
      var top = typeof props.top === "number" ? "".concat(props.top / 100, "rem") : props.top;
      var left = typeof props.left === "number" ? "".concat(props.left / 100, "rem") : props.left;
      if (props.position === "relative") {
        var _props$bg;
        return {
          position: props.position,
          width: w,
          height: h,
          top: isNil(top) ? undefined : top,
          left: isNil(left) ? undefined : left,
          backgroundImage: "url(".concat((_props$bg = props.bg) !== null && _props$bg !== void 0 ? _props$bg : "", ")")
        };
      }
      return {
        position: props.position,
        width: w,
        height: h,
        top: top,
        left: left,
        backgroundImage: "url(".concat((_props$bg2 = props.bg) !== null && _props$bg2 !== void 0 ? _props$bg2 : "", ")")
      };
    });
    var active = computed(function () {
      return props.active ? "url(".concat(props.active, ")") : "";
    });
    onMounted(function () {
      if (props.active) {
        new Image().src = props.active;
      }
    });
    return {
      __sfc: true,
      props: props,
      style: style,
      active: active
    };
  }
});